// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".reset-link[data-v-12c06307] {\n  color: #51d182;\n}\n.reset-link[data-v-12c06307]:hover {\n    text-decoration: underline;\n    cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
